import { SET_VO } from './types';

const initialState = {};

export const voReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_VO:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export const voSelectors = {
  selectVODealerEmail: (state: any): string | null => {
    const vo = state.vo;

    if (typeof vo.salesRepresentative?.email === 'string') {
      return vo.salesRepresentative.email;
    }

    if (typeof vo.salesManager?.email === 'string') {
      return vo.salesManager.email;
    }

    return null;
  },
  selectVOEntity: (state: any) => state.vo,
  selectVOId: (state: any) => state.vo.vendorOpportunityId,
};
